import React, { useState } from "react";
import {
  TextField,
  Select,
  MenuItem,
  RadioGroup,
  FormControlLabel,
  Radio,
  Button,
  Typography,
  Box,
  ButtonGroup,
} from "@mui/material";
import "./ItemEditor.css";
import { Input, Space } from "antd";

interface ItemEditorProps {
  title: { id: string; value: string };
  status: "OK" | "Pending" | "Issue" | "Limbo";
  onSave: () => void;
  onDelete: () => void;
  onTitleChange: (newTitle: { id: string; value: string }) => void;
}

const ItemEditor: React.FC<ItemEditorProps> = ({
  title,
  status,
  onSave,
  onDelete,
  onTitleChange,
}) => {
  const [selectedStatus, setSelectedStatus] = useState(status);

  const handleStatusChange = (
    newStatus: "OK" | "Pending" | "Issue" | "Limbo"
  ) => {
    setSelectedStatus(newStatus);
  };

  const handleTitleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    const [id, ...rest] = newValue.split(" - ");
    onTitleChange({ id: id.trim(), value: rest.join("").trim() });
  };

  const displayTitle = `${title.id || "No ID"} ${title.value || "Untitled"}`;

  return (
    <div className="main-edit">
      <div className="editor-header">
        <Box
          className="header"
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h6">Editing: {displayTitle}</Typography>
          <Box
            className={`${selectedStatus.toLowerCase()}-select`}
            sx={{ p: "5px 10px", borderRadius: 4, fontWeight: "bold" }}
          >
            {selectedStatus}
          </Box>
        </Box>
      </div>
      <Box
        className="item-editor"
        sx={{
          p: 2,
        }}
      >
        <Box
          className="body edit-upper-part"
          sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 2 }}
        >
          <div className="edit-form-field">
            <label htmlFor="Title">Title</label>
            <TextField
              variant="outlined"
              size="small"
              placeholder="Enter text"
              sx={{ width: "450px", borderRadius: "12px" }}
              value={displayTitle}
              onChange={handleTitleChange}
            />
          </div>
          <div className="edit-form-field">
            <label htmlFor="Title">Video URL</label>
            <TextField
              variant="outlined"
              size="small"
              placeholder="Enter URL"
              sx={{ width: "450px" }}
            />
          </div>

          <div className="edit-form-field">
            <label htmlFor="Category">Category</label>
            <Select
              defaultValue=""
              displayEmpty
              variant="outlined"
              sx={{ width: "450px" }}
            >
              <MenuItem value="" disabled>
                Select Category
              </MenuItem>
              <MenuItem value="Category 1">Category 1</MenuItem>
              <MenuItem value="Category 2">Category 2</MenuItem>
            </Select>
          </div>

          <RadioGroup row aria-label="compulsory" name="compulsory">
            <FormControlLabel
              value="compulsory"
              control={<Radio />}
              label="Compulsory"
            />
            <FormControlLabel
              value="optional"
              control={<Radio />}
              label="Optional"
            />
          </RadioGroup>

          <div className="footer-button-grp">
            <ButtonGroup variant="contained" aria-label="Basic button group">
              <Button
                className={`ok ${selectedStatus === "OK" ? "ok-select" : "ok"}`}
                onClick={() => handleStatusChange("OK")}
              >
                OK
              </Button>
              <Button
                className={`pending ${
                  selectedStatus === "Pending" ? "pending-select" : "pending"
                }`}
                onClick={() => handleStatusChange("Pending")}
              >
                Pending
              </Button>
              <Button
                className={`issue ${
                  selectedStatus === "Issue" ? "issue-select" : "issue"
                }`}
                onClick={() => handleStatusChange("Issue")}
              >
                Issue
              </Button>
              <Button
                className={`limbo ${
                  selectedStatus === "Limbo" ? "limbo-select" : "limbo"
                }`}
                onClick={() => handleStatusChange("Limbo")}
              >
                Limbo
              </Button>
            </ButtonGroup>

            <div className="compact-input-text-field">
              <Space.Compact style={{ width: "100%" }}>
                <Input defaultValue="Notes" />
                <Button onClick={onSave}>Save</Button>
              </Space.Compact>
            </div>
            <div className="dlt-btn">
              <Button variant="outlined" color="error">
                Delete
              </Button>
            </div>
          </div>
        </Box>
      </Box>
    </div>
  );
};
export default ItemEditor;
